import type { RelationshipTargetKind } from '@cli-types/core-engine/add-field.js'

export function formatKind(kind: RelationshipTargetKind): string {
  if (kind === 'user') return 'User'
  if (kind === 'form') return 'form'
  if (kind === 'single') return 'Single'
  return 'Entity'
}
